import React from 'react';
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';

import { Select, Cross } from '@helpers/icon-dictionary';

import { AccuracyColors, ScoreBandColors } from '@components/view-key/view-key-colors';
import SvgIcon from '@components/svg-icon/svg-icon';

import useQuickSelector from '../hooks/use-quick-selector';
import { ModalContentRow, ModalContentHeader, AllCellsIcon, ColorBlock } from '../styled';

import getTranslations from '../translations';

const AccuracyModalContent = props => {
  const { closeContextMenu } = props;
  /**
   * Hooks
   */
  const { i18n } = useLocalisation();
  const { cleanAssignmentHashKeys, selectAccuracyBetween, selectAllAssignments, selectCurrentAssigned } =
    useQuickSelector({ closeContextMenu });

  /**
   * Translations
   */
  const {
    SELECT_TEXT,
    ALL_CELLS_TEXT,
    ALL_CURRENTLY_ASSIGN_TEXT,
    ACCURACY_1_TO_20_TEXT,
    ACCURACY_21_TO_40_TEXT,
    ACCURACY_41_TO_60_TEXT,
    ACCURACY_61_TO_80_TEXT,
    ACCURACY_81_TO_100_TEXT,
    CLEAN_SELECTION_TEXT
  } = getTranslations({ i18n });

  // eslint-disable-next-line react/prop-types
  const renderModalContentRow = ({ dataTestId, onClickHandler, color, text }) => (
    <ModalContentRow
      data-testid={dataTestId}
      onClick={onClickHandler}
      role="button"
      tabIndex="-1"
    >
      <ColorBlock bgColor={color} />

      {text}
    </ModalContentRow>
  )

  return (
    <>
      <ModalContentHeader>{SELECT_TEXT}</ModalContentHeader>
      <ModalContentRow data-testid="select-all" onClick={selectAllAssignments} role="button" tabIndex="-1">
        <AllCellsIcon>
          <SvgIcon icon={Select} />
        </AllCellsIcon>
        {ALL_CELLS_TEXT}
      </ModalContentRow>

      <ModalContentRow role="button" tabIndex="-1" onClick={selectCurrentAssigned}>
        <ColorBlock data-testid="select-current-assigned" bgColor={AccuracyColors.currentlyAssigned} />
        {ALL_CURRENTLY_ASSIGN_TEXT}
      </ModalContentRow>

      {renderModalContentRow({
        dataTestId: 'select-accuracy-1-to-20',
        onClickHandler: () => selectAccuracyBetween(0, 20),
        color: ScoreBandColors.completed1to20.default,
        text: ACCURACY_1_TO_20_TEXT
      })}

      {renderModalContentRow({
        dataTestId: 'select-accuracy-21-to-40',
        onClickHandler: () => selectAccuracyBetween(21, 40),
        color: ScoreBandColors.completed21to40.default,
        text: ACCURACY_21_TO_40_TEXT
      })}

      {renderModalContentRow({
        dataTestId: 'select-accuracy-41-to-60',
        onClickHandler: () => selectAccuracyBetween(41, 60),
        color: ScoreBandColors.completed41to60.default,
        text: ACCURACY_41_TO_60_TEXT
      })}

      {renderModalContentRow({
        dataTestId: 'select-accuracy-61-to-80',
        onClickHandler: () => selectAccuracyBetween(61, 80),
        color: ScoreBandColors.completed61to80.default,
        text: ACCURACY_61_TO_80_TEXT
      })}

      {renderModalContentRow({
        dataTestId: 'select-accuracy-81-to-100',
        onClickHandler: () => selectAccuracyBetween(81, 100),
        color: ScoreBandColors.completed81to100.default,
        text: ACCURACY_81_TO_100_TEXT
      })}

      <ModalContentRow data-testid="select-clean-cells" onClick={cleanAssignmentHashKeys} role="button" tabIndex="-1">
        <AllCellsIcon>
          <SvgIcon icon={Cross} />
        </AllCellsIcon>
        {CLEAN_SELECTION_TEXT}
      </ModalContentRow>
    </>
  );
};

AccuracyModalContent.propTypes = {
  closeContextMenu: PropTypes.func.isRequired
};

export default AccuracyModalContent;



// WEBPACK FOOTER //
// ./components/student-list/quick-selector/accuracy-modal-content/index.js